import React from 'react';
import {CommonShow} from '../Common';
import {getShowFields} from './Common';

export const SiteShow = props => (
  <CommonShow
    {...{
      ...props,
      fields: getShowFields(),
    }}
  />
);
